/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './DimensionCurve.css';
import ReactEcharts from 'echarts-for-react'
import moment from 'moment'


const list=[
    {
        info:'所有平台',
        color:'#ffd70d',
    },{
        info:'微信',
        color:'#c2e1c5',
    },{
        info:'微博',
        color:'#fac8a7',
    },{
        info:'知乎',
        color:'#abd9f2',
    },{
        info:'今日头条',
        color:'#f1b1ad',
    }
    
]

// let [wxDataSp,wbDataSp,ttDataSp,zhDataSp]=[[],[],[],[]]
// let [wxDataFa,wbDataFa,ttDataFa,zhDataFa]=[[],[],[],[]]
// let [wxDataPa,wbDataPa,ttDataPa,zhDataPa]=[[],[],[],[]]

// for(var i=0;i<30;i++){
//     wxDataSp.push((Math.sin(i / 5) * (i / 5 - 10) + i / 6) * 5)
//     wbDataSp.push((Math.cos(i / 5) * (i / 5 - 10) + i / 6) * 5)
//     zhDataSp.push((Math.sin(i / 6) * (i / 6 - 10) + i / 6) * 5)
//     ttDataSp.push((Math.cos(i / 7) * (i / 7 - 10) + i / 7) * 5)

//     wxDataFa.push((Math.cos(i / 5) * (i / 5 - 10) + i / 6) * 5)
//     wbDataFa.push((Math.sin(i / 5) * (i / 5 - 10) + i / 6) * 5)
//     zhDataFa.push((Math.cos(i / 6) * (i / 6 - 10) + i / 6) * 5)
//     ttDataFa.push((Math.sin(i / 7) * (i / 7 - 10) + i / 7) * 5)

//     wxDataPa.push((Math.sin(i / 7) * (i / 7 - 10) + i / 6) * 5)
//     wbDataPa.push((Math.cos(i / 5) * (i / 5 - 10) + i / 6) * 5)
//     zhDataPa.push((Math.sin(i / 6) * (i / 6 - 10) + i / 6) * 5)
//     ttDataPa.push((Math.cos(i / 7) * (i / 7 - 10) + i / 7) * 5)

// }



class DimensionCurve extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            ac:'0',
            spread:[],
            favorite:[],
            participate:[]
        }
        this.getOption = this.getOption.bind(this)
        this.changeJson =this.changeJson.bind(this)
    }
    // componentWillUpdate() {
    //     console.log(this.props)
    // }

    componentWillMount() {
        
        const {totalDataSp,totalDataFa,totalDataPa}=this.props.json

        let [x,y,z]=[[],[],[]]
        let xValue,yValue,zValue
        for(var i=0;i<30;i++){
            xValue=totalDataSp[i]
            yValue=totalDataFa[i]
            zValue=totalDataPa[i]
            x.push(xValue)
            y.push(yValue)
            z.push(zValue)
        }
        this.setState({
            spread:x,
            favorite:y,
            participate:z
        })

    }


   
    changeJson=(index)=>{
     

        this.setState({
            ac:index,
        })
        this.propsJson(index)

      


    }


    propsJson=(index)=>{
        let [x,y,z]=[[],[],[]]
        let xValue,yValue,zValue
        const {wxDataSp,wbDataSp,ttDataSp,zhDataSp,wxDataFa,wbDataFa,ttDataFa,zhDataFa,wxDataPa,wbDataPa,ttDataPa,zhDataPa,totalDataSp,totalDataFa,totalDataPa}=this.props.json
        
        if(index==0){
            for(var i=0;i<30;i++){
                xValue=totalDataSp[i]
                yValue=totalDataFa[i]
                zValue=totalDataPa[i]
                x.push(xValue)
                y.push(yValue)
                z.push(zValue)
            }
        }else if(index==1){
            for(var i=0;i<30;i++){
                xValue=wxDataSp[i]
                yValue=wxDataFa[i]
                zValue=wxDataPa[i]
                x.push(xValue)
                y.push(yValue)
                z.push(zValue)
            }
        }else if(index==2){
            for(var i=0;i<30;i++){
                xValue=wbDataSp[i]
                yValue=wbDataFa[i]
                zValue=wbDataPa[i]
                x.push(xValue)
                y.push(yValue)
                z.push(zValue)
            }
        }else if(index==3){
            for(var i=0;i<30;i++){
                xValue=zhDataSp[i]
                yValue=zhDataFa[i]
                zValue=zhDataPa[i]
                x.push(xValue)
                y.push(yValue)
                z.push(zValue)
            }
        }else if(index==4){
            for(var i=0;i<30;i++){
                xValue=ttDataSp[i]
                yValue=ttDataFa[i]
                zValue=ttDataPa[i]
                x.push(xValue)
                y.push(yValue)
                z.push(zValue)
            }
        }else{

        }


        this.setState({
            spread:x,
            favorite:y,
            participate:z
        })


    }


    getOption = () => {
        // console.log(this.props)
        // var xAxisData = [];
        // var data1 = [];
        // var data2 = [];
        // var data3 = [];
        // var data4 = [];
        // var data5 = [];
        // for (var i = 0; i < 30; i++) {
        //     // xAxisData.push('类目' + i);
        //     data1.push((Math.sin(i / 5) * (i / 5 - 10) + i / 6) * 5);
        //     data2.push((Math.cos(i / 5) * (i / 5 - 10) + i / 6) * 5);
        //     data3.push((Math.cos(i / 6) * (i / 6 - 10) + i / 6) * 5);
        //     data4.push((Math.cos(i / 7) * (i / 7 - 10) + i / 6) * 5);
        //     var ss = data1[i] + data2[i] + data3[i] + data4[i]
        //     data5.push(ss)
        // }
        // console.log(this.props.json,this.props.json[0],this.props.json[1])
        //  let data1=[].concat(this.props.json[0])
        //  let data2=[].concat(this.props.json[1])
        //  let data3=[].concat(this.props.json[2])
        //  let data4=[].concat(this.props.json[3])
        //  let data5=[].concat(this.props.json[4])
        let [dataSp,dataFa,dataPa]=[this.state.spread,this.state.favorite,this.state.participate]

        // for(var i=0;i<30;i++){ data5.push(data1[i]+data2[i]+data3[i]+data4[i]) }
        const timeArr = []

        const m=(this.props.time.substring(5,7))-1
        const d=Number(this.props.time.substring(8,10))+1
        let time= moment().set({'month':m,'date':d})
        for (var i = 0; i < 30; i++) {
            timeArr.unshift(time.subtract(1, 'days').format('MM-DD'))
            // timeArr.push(i)
        }
        
        // console.log(timeArr)
        // console.log(data5,data1,data2,data3,data4)

        const option = {
            title: {
                text: `三维曲线图 - ${this.props.items.name}`,
                subtext: '数据来源：数字品牌榜',
                // sublink:'',
                x: '20'
            },
            color: [
                '#CD6C5B', '#71CA5C', '#5EA4CE'
            ],
            legend: {
                data: [
                    '传播度','好感度','参与度'
                ],
                bottom: '20',
                right:'20',
                orient:'vertical'
            },
            toolbox: {
                right: 20,
                show: true,
                feature: {
                    mark: {
                        show: true
                    },
                    //          dataView : {show: true, readOnly: false},
                    magicType: {
                        show: true,
                        type: ['pie', 'funnel']
                    },
                    restore: {
                        show: true
                    },
                    saveAsImage: {
                        show: true
                    }
                }
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                },
                formatter:function(params,data){
                    let [box,tips]=[[`${params[0].name}<br/>`],'']

                    for( i in params){
                        tips = (`${params[i].marker}${params[i].seriesName}:${params[i].data}%<br/>`)
                    
                        box.push(tips)
                        
                    }
                    
                    return box.join('')

                 


                }
            },
            xAxis: {
                data: timeArr,
                type: 'category',
                silent: false,
                splitLine: {
                    show: false
                }
            },
            yAxis: [
                {
                    type: 'value',
                    // boundaryGap: [0.2, 0.2]
                    // max:100, 
                    axisLabel:{
                        formatter:'{value}%',
                        
                    }
                }

            ],
            series: [
                {
                    name: '传播度',
                    type: 'line',
                    // stack: '总值',
                    data: dataSp,
                    animationDelay: function (idx) {
                        return idx * 10;
                    }
                }, {
                    name: '好感度',
                    type: 'line',
                    // stack: '总值',
                    data: dataFa,
                    animationDelay: function (idx) {
                        return idx * 10 + 100;
                    }
                },
                 {
                    name: '参与度',
                    type: 'line',
                    // stack: '总值', 
                    data: dataPa,
                    animationDelay: function (idx) {
                        return idx * 10 + 100;
                    }
                }, 
                // {
                //     name: '今日头条',
                //     type: 'bar',
                //     stack: '总值',
                //     data: data4,
                //     animationDelay: function (idx) {
                //         return idx * 10 + 100;
                //     }
                // }, {
                //     name: 'DB总值',
                //     type: 'line',
                //     lineStyle: {
                //         normal: {
                //             type: 'dashed',
                //             color: '#777'
                //         }
                //     },
                //     // label:{   normal:{       show:true,       position:'top',       color:'#000'
                //     //  } },
                //     data: data5,
                //     // yAxisIndex:1
                // }
            ],
            animationEasing: 'elasticOut',
            animationDelayUpdate: function (idx) {
                return idx * 5;
            }
        };
        return option
    }

    render() {

        // console.log(timeArr)
        // console.log(this.state.ac)

        return (
        <div className={s.root}>
            <ul>
                {list.map((i,index)=>{
                    let bgColor=(index==this.state.ac?i.color:'#ccc')
                    let spanColor=(index==this.state.ac?'#666':'#ccc')
                return    (
                        <li key={index} onClick={()=>this.changeJson(index)}>
                            <i style={{backgroundColor:bgColor}}></i>
                            <span style={{color:spanColor}}>{i.info}</span>
                        </li>
                        
                    )
                })}
            </ul>
            <ReactEcharts
            option={this.getOption()}
            style={{
            height: '550px',
            width:'100%',
            
            borderRadius: '4px'
            }}
            className={s.charts}
            notMerge={true}
            lazyUpdate={true}
            theme={"theme_name"}
            onChartReady={this.onChartReadyCallback}/>
        </div>
        )

    }
}

export default withStyles(s)(DimensionCurve);



// WEBPACK FOOTER //
// src/components/DimensionCurve/DimensionCurve.js